/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { theme } from '../../styles/theme'

const footerStyles = css`
  background: ${theme.colors.light};
  color: #111111;
  font-size: 14px;
  text-align: center;
  
  a {
    color: #111111;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .site-info .container > div {
    padding: 30px;
  }
`

export const Footer = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleGettingStartedClick = (e: React.MouseEvent) => {
    e.preventDefault()
    
    if (location.pathname === '/') {
      // Already on home page, just scroll to section
      const element = document.getElementById('getting-started')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    } else {
      // Navigate to home page and then scroll to section
      navigate('/')
      setTimeout(() => {
        const element = document.getElementById('getting-started')
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    }
  }

  return (
    <footer css={footerStyles}>
      <div className="site-info">
        <div className="container">
          <div>
            <p className="small">
              <Link to="/">Home</Link> | <a href="#" onClick={handleGettingStartedClick}>Getting Started</a> |&nbsp;
              <Link to="/retirement-planner">Retirement Planner</Link> | <Link to="/videos">Videos</Link> | <Link to="/articles">Articles</Link> | <Link to="/faq">FAQ</Link>
            </p>
            <p className="small">
              <Link to="/terms-of-service">Terms of Service</Link> |&nbsp;
              <Link to="/privacy-policy">Privacy Policy</Link>
            </p>
            <p className="small">Copyright © Zehnlabs. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  )
}